import { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/Button";
import { ClientInfoV2 } from "../../components/ClientInfo";
import { CustomFormatInputV2 } from "../../components/Input";
import { CustomSelectV2 } from "../../components/Selector";
import { BigFortuneTableV2 } from "../../components/Table/BigFortuneTable";
import { MonthFortuneTableV2 } from "../../components/Table/MonthFortuneTable";
import { SajuTableV3 } from "../../components/Table/SajuTable";
import { SmallFortuneTableV2 } from "../../components/Table/SmallFortuneTable";
import { AuthStateContext } from "../../contexts/AuthStateContext";
import {
  CURRENTROUTE,
  GENDERTYPE,
  SaveDataContext,
} from "../../contexts/SaveDataContext";
import { getSaju } from "../../framework/api";
import { createSmallFortuneTableArray } from "../../utils/createSmallFortuneTableArray";
import { defaultSet, timeOptions } from "../../utils/data";
import {
  convertDateString,
  convertTimeString,
  getCurrentMonth,
  getCurrentYear,
  getHMString,
  getYMDString,
  formatDateInput,
  getTimeOptionValueFromHHmm,
} from "../../utils/timeConvert";
import { HundredList, Root } from "../../utils/types";
import { urlNav, postData } from "../../utils/urlNav";

export default function AppCompatiblePage() {
  // 1. 파라미터 찾기.
  const params = new URLSearchParams(window.location.search);
  const nickNameParam = params.get("nickName");
  const genderParam = params.get("gender") as GENDERTYPE;
  const birthTypeParam = params.get("birthType");
  const yearMonthDayParam = params.get("yearMonthDay");
  const hourMinParam = params.get("hourMin");
  const unknownTimeParam = params.get("unknownTime");

  const _nickNameParam = params.get("_nickName");
  const _genderParam = params.get("_gender") as GENDERTYPE;
  const _birthTypeParam = params.get("_birthType");
  const _yearMonthDayParam = params.get("_yearMonthDay");
  const _hourMinParam = params.get("_hourMin");
  const _unknownTimeParam = params.get("_unknownTime");

  const {
    mailUser,
    femailUser,
    loadMailUser,
    loadFemailUser,
    saveMailUser,
    saveFemailUser,
    reset,
  } = useContext(SaveDataContext);

  // 2. 파라미터 값 설정. -> 해당 파라미터가 없는경우 context에 있는 default값 사용.
  const nickName = nickNameParam || mailUser.nickName;
  const genderType = genderParam || mailUser.genderType;
  const birthDayType = birthTypeParam || mailUser.birthDayType;
  const time = hourMinParam || mailUser.time;
  const birthday = yearMonthDayParam || mailUser.birthday;
  const unknownTime = unknownTimeParam === "true" || mailUser.unknownTime;

  const _nickName = _nickNameParam || femailUser.nickName;
  const _genderType = _genderParam || femailUser.genderType;
  const _birthDayType = _birthTypeParam || femailUser.birthDayType;
  const _time = _hourMinParam || femailUser.time;
  const _birthday = _yearMonthDayParam || femailUser.birthday;
  const _unknownTime = _unknownTimeParam === "true" || femailUser.unknownTime;

  const navigate = useNavigate();
  const printRef = useRef<HTMLDivElement>(null);
  const [firstResult, setFirstResult] = useState<Root>(defaultSet);
  const [secondResult, setSecondResult] = useState<Root>(defaultSet);
  const [hundredList, setHundredList] = useState<HundredList[]>(
    createSmallFortuneTableArray(defaultSet.hundredList, defaultSet.bigFortune)
  );
  const [_hundredList, _setHundredList] = useState<HundredList[]>(
    createSmallFortuneTableArray(defaultSet.hundredList, defaultSet.bigFortune)
  );

  const [loading, setLoading] = useState(true);
  const [_loading, _setLoading] = useState(true);
  const [yearMonthDay, setYearMonthDay] = useState(
    convertDateString(birthday) ?? getYMDString(new Date())
  );
  const [_yearMonthDay, _setYearMonthDay] = useState(
    convertDateString(_birthday) ?? getYMDString(new Date())
  );
  const [hourMin, setHourMin] = useState(
    convertTimeString(time) ?? getHMString(new Date())
  );
  const [_hourMin, _setHourMin] = useState(
    convertTimeString(_time) ?? getHMString(new Date())
  );
  const [birthType, setBirthType] = useState(birthDayType);
  const [_birthType, _setBirthType] = useState(_birthDayType);
  const [gender, setGender] = useState(genderType);
  const [_gender, _setGender] = useState(_genderType);

  const [currentBigFortune, setCurrentBigFortune] = useState<number | null>(
    null
  );
  const [currentSmallFortune, setCurrentSmallFortune] = useState<number | null>(
    null
  );
  const [currentMonthFortune, setCurrentMonthFortune] = useState<number | null>(
    null
  );

  const [_currentBigFortune, _setCurrentBigFortune] = useState<number | null>(
    null
  );
  const [_currentSmallFortune, _setCurrentSmallFortune] = useState<
    number | null
  >(null);
  const [_currentMonthFortune, _setCurrentMonthFortune] = useState<
    number | null
  >(null);

  // const [inputDisabled, setInputDisabled] = useState(false);
  const [currentTimeOption, setCurrentTimeOption] = useState(
    getTimeOptionValueFromHHmm(unknownTime ? "????" : time)
  );
  // const [isHourMinFocused, setIsHourMinFocused] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.currentTarget.value;
    setCurrentTimeOption(value);
    setHourMin(value);
    // if (value === "default") {
    //   setInputDisabled(false);
    //   setCurrentTimeOption(value);
    // } else {
    //   setInputDisabled(true);
    //   setCurrentTimeOption(value);
    //   setHourMin(value);
    // }
  };

  // const [_inputDisabled, _setInputDisabled] = useState(false);
  const [_currentTimeOption, _setCurrentTimeOption] = useState(
    getTimeOptionValueFromHHmm(_unknownTime ? "????" : _time)
  );
  const [_isHourMinFocused, _setIsHourMinFocused] = useState(false);

  const _handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.currentTarget.value;
    _setCurrentTimeOption(value);
    _setHourMin(value);
    // if (value === "default") {
    //   _setInputDisabled(false);
    //   _setCurrentTimeOption(value);
    // } else {
    //   _setInputDisabled(true);
    //   _setCurrentTimeOption(value);
    //   _setHourMin(value);
    // }
  };

  const { authState } = useContext(AuthStateContext);

  const onClickSaveButton = () => {
    loadMailUser({
      genderType: gender,
      nickName: null,
      birthDayType: birthType,
      time: hourMin,
      birthday: yearMonthDay,
      unknownTime: hourMin === "????" ? true : false,
    });

    // 로그인한 회원이라면
    if (authState) {
      saveMailUser({
        nickName: null,
        birthday: yearMonthDay,
        time: hourMin,
        birthDayType: birthType,
        genderType: gender,
        unknownTime: hourMin === "????" ? true : false,
      });
      navigate("/app/MyPage");
    } else {
      // 로그인하지 않은 회원이라면 로그인 페이지로 이동.
      // 세션 스토리지에 현재 값 객체를 문자열로 저장하고 다시 객체로 변환해서 저장하고 꺼낼때 다시 객체로 변환해서 사용하기
      const saveData = {
        route: CURRENTROUTE.COMPATIBLE,
        nickName: null,
        yearMonthDay: yearMonthDay,
        hourMin: hourMin,
        birthType: birthType,
        gender: gender,
        unknownTime: hourMin === "????" ? true : false,
      };
      sessionStorage.setItem("sessionSaveData", JSON.stringify(saveData));
      navigate("/app/login");
    }
  };
  const _onClickSaveButton = () => {
    loadFemailUser({
      genderType: _gender,
      nickName: null,
      birthDayType: _birthType,
      time: _hourMin,
      birthday: _yearMonthDay,
      unknownTime: _hourMin === "????" ? true : false,
    });

    // 로그인한 회원이라면
    if (authState) {
      saveFemailUser({
        nickName: null,
        birthday: _yearMonthDay,
        time: _hourMin,
        birthDayType: _birthType,
        genderType: _gender,
        unknownTime: _hourMin === "????" ? true : false,
      });
      navigate("/app/MyPage");
    } else {
      // 로그인하지 않은 회원이라면 로그인 페이지로 이동.
      // 세션 스토리지에 현재 값 객체를 문자열로 저장하고 다시 객체로 변환해서 저장하고 꺼낼때 다시 객체로 변환해서 사용하기
      const saveData = {
        route: CURRENTROUTE.COMPATIBLE,
        nickName: null,
        yearMonthDay: _yearMonthDay,
        hourMin: _hourMin,
        birthType: _birthType,
        gender: _gender,
        unknownTime: _hourMin === "????" ? true : false,
      };
      sessionStorage.setItem("sessionSaveData", JSON.stringify(saveData));
      navigate("/app/login");
    }
  };

  const onClickSeeFortune = () => {
    if (
      hourMin.length !== 4 ||
      yearMonthDay.length !== 8 ||
      _hourMin.length !== 4 ||
      _yearMonthDay.length !== 8
    ) {
      alert("입력값을 확인하세요.");
      return;
    }

    // 입력값 변경 여부 확인
    const isMaleChanged =
      gender !== mailUser.genderType ||
      birthType !== mailUser.birthDayType ||
      yearMonthDay !== mailUser.birthday ||
      hourMin !== mailUser.time;

    const isFemaleChanged =
      _gender !== femailUser.genderType ||
      _birthType !== femailUser.birthDayType ||
      _yearMonthDay !== femailUser.birthday ||
      _hourMin !== femailUser.time;

    // 3. 입력 값을 파라미터로 넘겨서 사주 결과 조회.
    const params = new URLSearchParams({
      gender: gender,
      birthType: birthType,
      yearMonthDay: yearMonthDay,
      hourMin: hourMin,
      unknownTime: hourMin === "????" ? "true" : "false",
      _gender: _gender,
      _birthType: _birthType,
      _yearMonthDay: _yearMonthDay,
      _hourMin: _hourMin,
      _unknownTime: _hourMin === "????" ? "true" : "false",
    });

    loadMailUser({
      genderType: gender,
      nickName: isMaleChanged ? null : mailUser.nickName, // 변경된 경우에만 닉네임 초기화
      birthDayType: birthType,
      time: hourMin,
      birthday: yearMonthDay,
      unknownTime: hourMin === "????" ? true : false,
    });

    loadFemailUser({
      genderType: _gender,
      nickName: isFemaleChanged ? null : femailUser.nickName, // 변경된 경우에만 닉네임 초기화
      birthDayType: _birthType,
      time: _hourMin,
      birthday: _yearMonthDay,
      unknownTime: _hourMin === "????" ? true : false,
    });

    navigate(`/app/compatible?${params.toString()}`);
  };

  const onClickBigFortune = (value: number) => {
    setCurrentBigFortune(value);
    setCurrentSmallFortune(null);
    setCurrentMonthFortune(null);
  };

  const onClickSmallFortune = (value: number) => {
    if (currentBigFortune) {
      setCurrentSmallFortune(value);
      setCurrentMonthFortune(null);
      getSaju
        .post<Root>(
          `/mobile/manse`,
          postData({
            gender: gender,
            birthType: birthType,
            yearMonthDay: yearMonthDay,
            hourMin: hourMin,
            unknownTime: unknownTime,
            currentBigFortune: currentBigFortune,
            currentSmallFortune: value,
          })
        )
        .then((resolve) => {
          const { monthFortune } = resolve.data;
          setFirstResult((prev) => {
            return { ...prev, monthFortune };
          });
        })
        .catch(function (error) {
          let errorMessage = error.message; // default to the generic error message

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            errorMessage = error.response.data.message;
          }

          alert(errorMessage ?? "유효하지 않은 값입니다.");
        });
    }
  };

  const _onClickBigFortune = (value: number) => {
    _setCurrentBigFortune(value);
    _setCurrentSmallFortune(null);
    _setCurrentMonthFortune(null);
  };
  const _onClickSmallFortune = (value: number) => {
    if (_currentBigFortune) {
      _setCurrentSmallFortune(value);
      _setCurrentMonthFortune(null);
      getSaju
        .post<Root>(
          `/mobile/manse`,
          postData({
            gender: _gender,
            birthType: _birthType,
            yearMonthDay: _yearMonthDay,
            hourMin: _hourMin,
            unknownTime: _unknownTime,
            currentBigFortune: _currentBigFortune,
            currentSmallFortune: value,
          })
        )
        .then((resolve) => {
          const { monthFortune } = resolve.data;
          setSecondResult((prev) => {
            return { ...prev, monthFortune };
          });
        })
        .catch(function (error) {
          let errorMessage = error.message; // default to the generic error message

          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            errorMessage = error.response.data.message;
          }

          alert(errorMessage ?? "유효하지 않은 값입니다.");
        })
        .finally(() => {});
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    // 4. 파라미터 값 설정. -> 해당 파라미터가 없는경우 context에 있는 default값 사용.
    const gender = genderParam || mailUser.genderType;
    const birthType = birthTypeParam || mailUser.birthDayType;
    const yearMonthDay = yearMonthDayParam || mailUser.birthday;
    const hourMin = hourMinParam || mailUser.time;
    const unknownTime = unknownTimeParam === "true" || mailUser.unknownTime;

    const _gender = _genderParam || femailUser.genderType;
    const _birthType = _birthTypeParam || femailUser.birthDayType;
    const _yearMonthDay = _yearMonthDayParam || femailUser.birthday;
    const _hourMin = _hourMinParam || femailUser.time;
    const _unknownTime = _unknownTimeParam === "true" || femailUser.unknownTime;

    setGender(gender);
    setBirthType(birthType);
    setYearMonthDay(yearMonthDay);
    setHourMin(hourMin);
    setCurrentTimeOption(
      getTimeOptionValueFromHHmm(unknownTime ? "????" : time)
    );
    // setInputDisabled(unknownTime);

    _setGender(_gender);
    _setBirthType(_birthType);
    _setYearMonthDay(_yearMonthDay);
    _setHourMin(_hourMin);
    _setCurrentTimeOption(
      getTimeOptionValueFromHHmm(_unknownTime ? "????" : _time)
    );
    // _setInputDisabled(_unknownTime);

    // First API call
    const firstApiCall = getSaju
      .post<Root>(
        `/mobile/manse`,
        postData({
          gender: gender,
          birthType: birthType,
          yearMonthDay: yearMonthDay,
          hourMin: hourMin,
          unknownTime: unknownTime,
          currentSmallFortune: getCurrentYear(),
          currentMonthFortune: getCurrentMonth(),
        })
      )
      .then((resolve) => {
        const { saju, hundredList, bigFortune } = resolve.data;
        setCurrentBigFortune(saju.fortune.big);
        setCurrentSmallFortune(saju.fortune.small);
        setCurrentMonthFortune(getCurrentMonth());
        setFirstResult(resolve.data);
        setHundredList(createSmallFortuneTableArray(hundredList, bigFortune));
      })
      .catch(function (error) {
        let errorMessage = error.message;

        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        }

        alert(errorMessage ?? "유효하지 않은 값입니다.");
      });

    // Second API call
    const secondApiCall = getSaju
      .post<Root>(
        `/mobile/manse`,
        postData({
          gender: _gender,
          birthType: _birthType,
          yearMonthDay: _yearMonthDay,
          hourMin: _hourMin,
          unknownTime: _unknownTime,
          currentSmallFortune: getCurrentYear(),
          currentMonthFortune: getCurrentMonth(),
        })
      )
      .then((resolve) => {
        const { saju, hundredList, bigFortune } = resolve.data;
        _setCurrentBigFortune(saju.fortune.big);
        _setCurrentSmallFortune(saju.fortune.small);
        _setCurrentMonthFortune(getCurrentMonth());
        setSecondResult(resolve.data);
        _setHundredList(createSmallFortuneTableArray(hundredList, bigFortune));
      })
      .catch(function (error) {
        let errorMessage = error.message;

        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        }

        alert(errorMessage ?? "유효하지 않은 값입니다.");
      });

    // Use Promise.all to wait for both API calls to complete
    Promise.all([firstApiCall, secondApiCall]).then(() => {
      // console.log("loadingFinish");
      setLoading(false);
      _setLoading(false);
    });
  }, [
    genderParam,
    birthTypeParam,
    yearMonthDayParam,
    hourMinParam,
    unknownTimeParam,
    _genderParam,
    _birthTypeParam,
    _yearMonthDayParam,
    _hourMinParam,
    _unknownTimeParam,
  ]);

  return (
    <div className="flex justify-center w-full min-h-full mb-3">
      {/* 가로모드 좌측 빈여백 */}
      {/* <div className="sm:w-[27%] sm:visible " /> */}
      {/* 메인 내용 */}
      <div className="w-full px-2">
        {/* 이규호 만세력 header */}
        <div className=" relative flex w-full py-[11px] justify-center">
          <button
            style={{
              fontSize: "max(32px,1vw)",
              fontFamily: "MapoGoldenPier",
              fontWeight: 800,
            }}
            // onClick={() => {
            //   reset();
            //   navigate(-1);
            // }}
          >
            이규호 만세력
          </button>
        </div>

        {/* 사주 정보 입력창  */}
        <div className="grid w-full grid-cols-7 gap-1 ">
          {/* 남성 입력창 */}
          <div className="grid grid-cols-3 col-span-3 gap-x-1 gap-y-2">
            {/* 년월일 시입력 시선택 */}
            <div className="grid grid-cols-4 col-span-3 gap-1">
              <div className="col-span-2 gap-1">
                {/* <CustomInputV2
                  maxLength={10}
                  type={"tel"}
                  name={"yearMonthDay"}
                  id="app_flutter_year_month_day_male"
                  label={"년월일"}
                  placeholder="1999/01/22"
                  className="col-span-2 h-[46px]"
                  value={formatDateInput(yearMonthDay)}
                  onChange={(e) => {
                    const newValue = e.currentTarget.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 8);
                    setYearMonthDay(newValue);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onClickSeeFortune();
                    }
                  }}
                /> */}
                <CustomFormatInputV2
                  maxLength={10}
                  type={"tel"}
                  name={"yearMonthDay"}
                  label={"년월일"}
                  placeholder="1999/01/22"
                  className="col-span-2 h-[46px]"
                  value={yearMonthDay}
                  onChange={(e) => {
                    const newValue = e.currentTarget.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 8);
                    setYearMonthDay(newValue);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onClickSeeFortune();
                    }
                  }}
                />
                {/* <CustomInputV2
                  maxLength={5}
                  type={"tel"}
                  name={"hourMin"}
                  id="app_flutter_hour_min_male"
                  label={"시 입력"}
                  disabled={inputDisabled}
                  placeholder="10:23"
                  className="col-span-1 h-[46px]"
                  value={formatTimeInput(hourMin)}
                  onChange={(e) => {
                    const newValue = e.currentTarget.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 4);
                    setHourMin(newValue);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onClickSeeFortune();
                    }
                  }}
                  onFocus={(e) => {
                    setHourMin("");
                    setIsHourMinFocused(true);
                  }}
                  onBlur={() => setIsHourMinFocused(false)}
                /> */}
              </div>

              <CustomSelectV2
                title="시 선택"
                options={timeOptions}
                value={currentTimeOption}
                id="app_flutter_time_options_male"
                className="col-span-2 h-[46px]"
                onChange={handleChange}
                // disabled={
                //   currentTimeOption === "default" &&
                //   hourMin.length > 0 &&
                //   !isHourMinFocused
                // }
              />
            </div>
            {/* 양,음,윤 성별 저장버튼 */}
            <div className="grid grid-cols-3 col-span-3 gap-1">
              <CustomSelectV2
                title="양,음,윤"
                options={[
                  { key: "양력", value: "SOLAR" },
                  { key: "음력", value: "LUNAR" },
                  { key: "윤달", value: "LEAP" },
                ]}
                id="app_flutter_birth_type_male"
                value={birthType}
                onChange={(e) => {
                  setBirthType(e.currentTarget.value);
                }}
                className="col-span-1 h-[46px]"
              />
              <CustomSelectV2
                title="성별"
                options={[
                  { key: "남", value: "MALE" },
                  { key: "여", value: "FEMALE" },
                ]}
                id="app_flutter_gender_male"
                value={gender}
                onChange={(e) => {
                  setGender(e.currentTarget.value as GENDERTYPE);
                }}
                className="col-span-1 h-[46px]"
              />

              <CustomButton
                onClick={onClickSaveButton}
                primaryType={false}
                disabled={hourMin.length !== 4 || yearMonthDay.length !== 8}
                id="app_flutter_save_male"
                text="저장"
                className="col-span-1 font-extrabold h-[46px]"
              />
            </div>
          </div>
          {/* <div className="min-h-full w-[1px] bg-slate-400" /> */}
          <CustomButton
            onClick={onClickSeeFortune}
            type="submit"
            id="app_flutter_see_fortune"
            primaryType={true}
            text="사주보기"
            className="h-full col-span-1 font-extrabold "
          />
          {/* 여성 입력창 */}
          <div className="grid grid-cols-3 col-span-3 gap-x-1 gap-y-2">
            {/* 년월일 시입력 시선택 */}
            <div className="grid grid-cols-4 col-span-3 gap-1">
              <div className="col-span-2 gap-1">
                {/* <CustomInputV2
                  maxLength={10}
                  type={"tel"}
                  name={"yearMonthDay"}
                  id="app_flutter_year_month_day_female"
                  label={"년월일"}
                  placeholder="1999/01/22"
                  className="col-span-2 h-[46px]"
                  value={formatDateInput(_yearMonthDay)}
                  onChange={(e) => {
                    const newValue = e.currentTarget.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 8);
                    _setYearMonthDay(newValue);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onClickSeeFortune();
                    }
                  }}
                /> */}
                <CustomFormatInputV2
                  maxLength={10}
                  type={"tel"}
                  name={"yearMonthDay"}
                  label={"년월일"}
                  placeholder="1999/01/22"
                  className="col-span-2 h-[46px]"
                  value={_yearMonthDay}
                  onChange={(e) => {
                    const newValue = e.currentTarget.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 8);
                    _setYearMonthDay(newValue);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onClickSeeFortune();
                    }
                  }}
                />
                {/* <CustomInputV2
                  maxLength={5}
                  type={"tel"}
                  name={"hourMin"}
                  id="app_flutter_hour_min_female"
                  label={"시 입력"}
                  disabled={_inputDisabled}
                  placeholder="10:23"
                  className="col-span-1 h-[46px]"
                  value={formatTimeInput(_hourMin)}
                  onChange={(e) => {
                    const newValue = e.currentTarget.value
                      .replace(/[^0-9]/g, "")
                      .slice(0, 4);
                    _setHourMin(newValue);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      onClickSeeFortune();
                    }
                  }}
                  onFocus={(e) => {
                    _setHourMin("");
                    _setIsHourMinFocused(true);
                  }}
                  onBlur={() => _setIsHourMinFocused(false)}
                /> */}
              </div>

              <CustomSelectV2
                title="시 선택"
                options={timeOptions}
                value={_currentTimeOption}
                id="app_flutter_time_options_female"
                className="col-span-2 h-[46px]"
                onChange={_handleChange}
                // disabled={
                //   _currentTimeOption === "default" &&
                //   _hourMin.length > 0 &&
                //   !_isHourMinFocused
                // }
              />
            </div>
            {/* 양,음,윤 성별 저장버튼 */}
            <div className="grid grid-cols-3 col-span-3 gap-1">
              <CustomSelectV2
                title="양,음,윤"
                options={[
                  { key: "양력", value: "SOLAR" },
                  { key: "음력", value: "LUNAR" },
                  { key: "윤달", value: "LEAP" },
                ]}
                id="app_flutter_birth_type_female"
                value={_birthType}
                onChange={(e) => {
                  _setBirthType(e.currentTarget.value);
                }}
                className="col-span-1 h-[46px]"
              />
              <CustomSelectV2
                title="성별"
                options={[
                  { key: "남", value: "MALE" },
                  { key: "여", value: "FEMALE" },
                ]}
                id="app_flutter_gender_female"
                value={_gender}
                onChange={(e) => {
                  _setGender(e.currentTarget.value as GENDERTYPE);
                }}
                className="col-span-1 h-[46px]"
              />

              <CustomButton
                onClick={_onClickSaveButton}
                primaryType={false}
                disabled={_hourMin.length !== 4 || _yearMonthDay.length !== 8}
                text="저장"
                id="app_flutter_save_female"
                className="col-span-1 h-[46px] font-extrabold"
              />
            </div>
          </div>
          {/* 사주보기 버튼 */}
        </div>
        {/* 가로 선 */}
        <div className="w-full h-[1px] bg-[#DCDCDC] my-2" />
        {/* 사주 테이블, 대운 테이블, 세운 테이블, 월운 테이블, 달력 테이블 */}
        <div className="flex w-full gap-3" ref={printRef}>
          {/* 남성 사주 정보 */}
          <div className="flex flex-col items-center w-1/2">
            <ClientInfoV2
              loading={loading}
              nickName={nickName}
              genderType={genderType}
              birthday={birthday}
              birthDayType={birthDayType}
              seasonName={firstResult.seasonName}
              summerTime={firstResult.summerTime}
              unknownTime={firstResult.unknownTime}
              solarDate={firstResult.solarBirthDay}
              lunaDate={firstResult.lunarBirthDay}
              age={firstResult.currentAge}
            />

            {/* saju table */}
            <SajuTableV3
              saju={firstResult.saju}
              loading={loading}
              unknownTime={firstResult.unknownTime}
            />

            <div className="w-full h-[2px] bg-[#3C3C3C] my-3 md:bg-transparent md:my-1" />

            {/* bigfortune */}
            <BigFortuneTableV2
              loading={loading}
              bigFortuneProps={firstResult.bigFortune}
              currentBigFortune={currentBigFortune}
              onClickBigFortune={onClickBigFortune}
            />

            <div className="w-full h-[2px] bg-[#3C3C3C] my-3 md:bg-transparent md:my-1" />

            {/* smallFortune */}
            <SmallFortuneTableV2
              loading={loading}
              currentSmallFortune={currentSmallFortune}
              onClickSmallFortune={onClickSmallFortune}
              hundredList={hundredList}
              currentBigFortune={currentBigFortune}
            />
            <div className="w-full h-[2px] bg-[#3C3C3C] my-3 md:bg-transparent md:my-1" />

            {/* monthFortune */}
            <MonthFortuneTableV2
              loading={loading}
              monthFortune={firstResult.monthFortune}
              currentMonthFortune={currentMonthFortune}
              onClickMonthFortune={setCurrentMonthFortune}
            />
          </div>
          {/* 여성 사주 정보 */}
          <div className="flex flex-col items-center w-1/2">
            <ClientInfoV2
              loading={_loading}
              nickName={_nickName}
              genderType={_genderType}
              birthday={_birthday}
              birthDayType={_birthDayType}
              seasonName={secondResult.seasonName}
              summerTime={secondResult.summerTime}
              unknownTime={secondResult.unknownTime}
              solarDate={secondResult.solarBirthDay}
              lunaDate={secondResult.lunarBirthDay}
              age={secondResult.currentAge}
            />

            {/* saju table */}
            <SajuTableV3
              saju={secondResult.saju}
              loading={_loading}
              unknownTime={secondResult.unknownTime}
            />

            <div className="w-full h-[2px] bg-[#3C3C3C] my-3 md:bg-transparent md:my-1" />

            {/* bigfortune */}
            <BigFortuneTableV2
              loading={_loading}
              bigFortuneProps={secondResult.bigFortune}
              currentBigFortune={_currentBigFortune}
              onClickBigFortune={_onClickBigFortune}
            />

            <div className="w-full h-[2px] bg-[#3C3C3C] my-3 md:bg-transparent md:my-1" />

            {/* smallFortune */}
            <SmallFortuneTableV2
              loading={_loading}
              currentSmallFortune={_currentSmallFortune}
              onClickSmallFortune={_onClickSmallFortune}
              hundredList={_hundredList}
              currentBigFortune={_currentBigFortune}
            />

            <div className="w-full h-[2px] bg-[#3C3C3C] my-3 md:bg-transparent md:my-1" />

            {/* monthFortune */}
            <MonthFortuneTableV2
              loading={_loading}
              monthFortune={secondResult.monthFortune}
              currentMonthFortune={_currentMonthFortune}
              onClickMonthFortune={_setCurrentMonthFortune}
            />
          </div>
        </div>
      </div>
      {/* 가로모드 우측 빈여백 */}
      {/* <div className="sm:w-[27%] sm:visible" /> */}
    </div>
  );
}
